/**
 * Returns the path a freshly-authenticated user should land on,
 * consuming any `signup_breed_intent` left by the landing-page
 * breed search.
 *
 * Usage:
 *   navigate(consumePostAuthRedirect());
 *
 * Behaviour:
 *   • If a literal `next=...` URL was provided (set via
 *     `setPostAuthRedirect()` before navigation), that wins. It also
 *     overrides the breed-intent path so deep-links into a specific
 *     listing always honour the user's original click.
 *   • Otherwise, if `localStorage.signup_breed_intent` is present →
 *     returns `/marketplace?breed=<encoded>` and clears the key so it
 *     only fires once per signup/login flow.
 *   • Otherwise returns the supplied default (defaults to /dashboard).
 */
const NEXT_KEY = "post_auth_next";

export function setPostAuthRedirect(next) {
  if (!next) return;
  try {
    localStorage.setItem(NEXT_KEY, next);
  } catch {
    /* ignore */
  }
}

export function consumePostAuthRedirect(fallback = "/dashboard") {
  try {
    const explicit = localStorage.getItem(NEXT_KEY);
    if (explicit && explicit.startsWith("/")) {
      localStorage.removeItem(NEXT_KEY);
      // Drop any breed-intent so we don't double-redirect.
      localStorage.removeItem("signup_breed_intent");
      return explicit;
    }
  } catch {
    /* fall through */
  }
  try {
    const intent = localStorage.getItem("signup_breed_intent");
    if (intent && intent.trim()) {
      localStorage.removeItem("signup_breed_intent");
      return `/marketplace?breed=${encodeURIComponent(intent.trim())}`;
    }
  } catch {
    /* localStorage unavailable — fall through to fallback */
  }
  return fallback;
}
